export const getParentCategories = (payload?: any) => ({
    type: "@saga/GET_PARENT_CATEGORIES",
    payload
});

